import { getLoadingBarTpl } from '../../model/tpl/loadingbar';
import { isDefined, truthy, falsy, parseInt10, parseStrIntToInt } from '../../utils/util';
import { getDatasWithOption, handleApiError } from '../../utils/service';
import { BREAKPOINTS } from '../../model/model';

class MyCharacterRanking {
  constructor(options) {
    const _ = this;

    if (!options) return;

    _.option = $.extend({
      wrap: null,
      apiDomain: '',
      staticDomain: '',
      serverId: 1,
      isLogin: false,
      global: window
    }, options);

    _.global = _.option.global;

    _.wrap = null;
    _.infoWrap = null;

    _.DISPLAY_CHARACTER_LEVEL_MIN = 60;
  }

  init() {
    const _ = this;

    _.infoWrap = $('.wrap-detail-info', _.option.wrap);

    if (falsy(_.option.isLogin)) {
      _.infoWrap.remove();

      return _;
    }

    _.setLoadingBar(true);

    _.setData();

    return _;
  }

  setData() {
    const _ = this;

    getDatasWithOption([{
      type: 'GET',
      url: `${_.option.apiDomain}/api/world/ranking/${_.option.serverId}/mycharacter`,
      dataType: 'json',
      xhrFields: {withCredentials: true}

    }], (data) => {
      _.setLoadingBar(false);
      _.setInstance(data);

    }, (data) => {
      if (data.responseJSON.result.errorCode === 'WORLD_RANK_NOT_EXIST_RANKING_SERVER') {
        // no process
      }

      _.setLoadingBar(false);

      _.setCharacters(null);

      handleApiError(data);
    });
  }

  setInstance(data) {
    const _ = this;

    _.setDate(data.rankCachedTime);
    _.setCharacters(data.rankCharacterList);

    const itemLength = $('.detail-info .detail-info-list', _.infoWrap).length;
    if (itemLength > 0) {
      $('.wrap-detail-info').show();
      $('.detail-info', _.infoWrap).slick({
        dots: true,
        arrows: false,
        infinite: true,
        speed: 250,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [{
          breakpoint: Number.MAX_VALUE,
          settings: 'unslick'
        }, {
          breakpoint: BREAKPOINTS.pc,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }]
      });

      $(_.global).on('resize.ui.mycharacterranking', $.proxy(_.resize, _));
      _.resize();

    } else {
      // no character
    }
  }

  setDate(rankCachedTime) {
    let str = rankCachedTime || '',
      matchArr = str.match(/\d+\.\d+\.\d+\./g);

    if (matchArr && matchArr.length) str = matchArr[0];
    $('.wrap-detail-info .date', this.wrap).text(str);
  }

  setCharacters(rankCharacterList) {
    const _ = this;

    if (!rankCharacterList || !Array.isArray(rankCharacterList) || rankCharacterList.length <= 0) {
      $('.wrap-detail-info', _.option.wrap).remove();
      return;
    }

    let tpl = '', level = 0, gameCharacter = null;
    rankCharacterList.forEach(function (value, index, array) {
      gameCharacter = value.gameCharacter;

      if (isDefined(gameCharacter)) {
        level = parseInt10(gameCharacter.level);

        if (level >= _.DISPLAY_CHARACTER_LEVEL_MIN) {
          tpl += _.getRankItemTpl({
            thumbObj: _.getClassThumbObj(gameCharacter),
            serverName: gameCharacter.serverName,
            characterName: gameCharacter.name,
            characterLevel: gameCharacter.level,
            classRank: value.classRank,
            serverRank: value.serverRank,
            grade: parseStrIntToInt(value.grade)
          });
        }
      }
    });

    $('.detail-info .detail-info-list', _.infoWrap).remove();
    $('.detail-info', _.infoWrap).append(tpl);
  }

  getClassThumbObj(data) {
    return {
      classId: (isDefined(data.classId)) ? data.classId : 1,
      gender: (data.gender === 0 ) ? 'm' : 'f' // 올초 리니지NP화 때, LineageCharcter로 api 응답이 바뀌면서 gender 가 MALE, FEMALE이 아니라 0(남자), 1(여자)로 응답 되도록 변경된 부분이 있어서 MALE, FEMALE이 아니라 0, 1로 판단하도록 변경되어야 할 것 같습니다.
    };
  }

  getRankItemTpl(data) {
    let grade = data.grade,
      classStr = 'grade' + grade;

    if(grade < 0) classStr = 'grade-none';

    const gradeIcon = (parseStrIntToInt(data.serverRank) <= 3 && parseStrIntToInt(data.serverRank) > 0) ? `top${data.serverRank}` : `${classStr}`;

    const tpl = `<div class="detail-info-list">
					<dl>
						<dt class="thumb">
						  <img src="${this.option.staticDomain}/resource/lineage/profile/char${data.thumbObj.classId}_${data.thumbObj.gender}.png">
						</dt>
						<dd>
							<strong class="name">${data.characterName}</strong><span class="server">${data.serverName}</span><span class="level">${data.characterLevel}Lv.</span>
						</dd>
					</dl>
					<div class="ranking-info">
						<ul>
							<li><strong>${data.serverRank}</strong><span>서버랭킹</span></li>
							<li><strong>${data.classRank}</strong><span>클래스랭킹</span></li>
							<li class="grade"><span class="star ${gradeIcon}"></span><span>등급</span></li>
						</ul>
					</div>
				</div>`

    return tpl;
  }

  setLoadingBar(flag) {
    const _ = this;

    if (truthy(flag)) {
      $('.detail-info', _.infoWrap).append(getLoadingBarTpl());

    } else {
      $('.loadingbar', _.infoWrap).remove();
    }
  }

  resize(evt) {
    $('.detail-info', this.infoWrap).slick('resize');
  }
}

export default MyCharacterRanking;


// WEBPACK FOOTER //
// ./_src/js/world/ranking/MyCharacterRanking.js